export const BASKET_REWARDS_ERROR_STATUS = {
  UNAVAILABLE: 'unable_to_add_rewards',
  UNABLE_TO_APPLY: 'basket_not_valid',
};
